import { render, staticRenderFns } from "./PowerDataBase.vue?vue&type=template&id=045b9236&scoped=true&"
import script from "./PowerDataBase.vue?vue&type=script&lang=js&"
export * from "./PowerDataBase.vue?vue&type=script&lang=js&"
import style0 from "./PowerDataBase.vue?vue&type=style&index=0&id=045b9236&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b9236",
  null
  
)

export default component.exports